/*
 *
 * CreateSafePasswordModal
 *
 * @version 1.0.0
 * @author Mauro La Barbera
 * @since 01-Aug-2025
*/

import { connect } from 'react-redux'
import { doHidePopup } from 'Store/actions/popup'
import { bindActionCreators } from 'redux'
import PciEmailDocumentsModal from './PciEmailDocumentsModal'
import { nullSafe } from 'Utility/globalMethods'

const mapDispatchToProps = dispatch => ({
  ...bindActionCreators({ doHidePopup }, dispatch)
})

const mapStateToProps = (state) => ({
  email: nullSafe(() => state.userProfiling.profiling.user.email, ''),
  primaryAction: nullSafe(() => state.popup.popupInfo.primaryAction, ''),
  idSurvey: nullSafe(() => state.popup.popupInfo.idSurvey, ''),
  partitaIva: nullSafe(() => state.popup.popupInfo.partitaIva, '')
})

export default connect(mapStateToProps, mapDispatchToProps, (stateProps, dispatchProps, mergeProps) => ({
  ...stateProps,
  ...mergeProps,
  actions: dispatchProps
}))(PciEmailDocumentsModal)
